// extracted by mini-css-extract-plugin
var _1 = "LogIn-module__content___GCOr4";
var _2 = "LogIn-module__grid___iS4Bi";
export { _1 as "content", _2 as "grid" }
